import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { provideDefaultConfig } from '@spartacus/core';
import { defaultSmartEditConfig } from './config/default-smart-edit-config';
import { interceptors } from './http-interceptors/index';
import { SmartEditLauncherService } from './services/smart-edit-launcher.service';

export function smartEditFactory(smartEditLauncherService: SmartEditLauncherService): () => void {
  const isReady = (): void => {
    smartEditLauncherService.load();
  };

  return isReady;
}

@NgModule({
  providers: [
    ...interceptors,
    provideDefaultConfig(defaultSmartEditConfig),
    provideAppInitializer(() => {
        const initializerFn = (smartEditFactory)(inject(SmartEditLauncherService));
        return initializerFn();
      }),
  ],
})
export class SmartEditRootModule {}
